<template>
  <div class="">
    <div class="container">
      <section id="landing" class="landing">
        <div
          class="bg"
          :style="`
            background: linear-gradient(
                0deg,
                rgba(0, 0, 0, 0.6) 0%,
                rgba(0, 0, 0, 0.6) 100%
              ),
              url('${staticUrl}/images/main-bg-offer.webp'),
              lightgray 0px -0.3px / 100% 191.696% no-repeat;
            background-repeat: no-repeat;
            background-position: top;
            background-size: cover;
          `"
        />
        <div class="info-box">
          <div class="info-box__before">
            {{ $t('offerEffortlessDesign') }}
          </div>
          <div class="info-box__title">
            <span>{{ transformSpaces[0] }}</span>
            <span>{{ transformSpaces[1] }}</span>
          </div>
          <div class="info-box__subtitle">
            {{ $t('innovativeOffer') }}
          </div>
          <div class="info-box__btn-wrapper">
            <ui-button
              :size="ButtonSizeType.large"
              :label="$t('tryForFree')"
              color="primary-offer"
              ref="btnRef"
              class="dwnload-btn btn btn_lg"
              @click="actionHandler"
            >
              <template v-if="!isMobile" #before
              >
                <IconWindows
                />
              </template>
            </ui-button>
            <ui-button
              :size="ButtonSizeType.large"
              :type="ButtonType.transparent"
              :label="$t('howToUse')"
              class="btn btn_lg"
              @click="startVideo('promo-yt')"
            >
              <template #before>
                <IconPlay/>
              </template>
            </ui-button>
          </div>
        </div>
      </section>
      <ModulesOfferSectionOfferUse/>
      <!-- <ModulesOfferSectionEmoutionOurClient /> -->
      <LazyModulesOfferSectionGallery v-if="isMount"/>
    </div>

    <LazyModulesOfferSectionFeedback v-if="isMount"/>
    <LazyModulesOfferSectionAdventages v-if="isMount"/>

    <div class="container">
      <LazyModulesOfferSectionAboutUs v-if="isMount"/>
      <!-- <LazyModulesOfferSectionManagment v-if="isMount" /> -->
      <LazyModulesOfferSectionPlans v-if="isMount"/>
      <UiTariffsInfo/>
      <LazyModulesOfferSectionRequrements v-if="isMount"/>
    </div>
  </div>
  <VideoModal
    :show="showVideoModal"
    :video="video"
    @update:show="
      () => {
        showVideoModal = false;
      }
    "
  />
</template>

<script lang="ts" setup>
import {ref} from 'vue';
import {useI18n} from 'vue-i18n';
import IconWindows from '~/assets/svg/windows-icon.svg';
import {ButtonSizeType, ButtonType} from '~/interfaces/ui/button';
import IconPlay from '~/assets/svg/play_white.svg';
import {useRuntimeConfig} from '#imports';
import {useUserStore} from '~/modules/User/user.store';
import EmoutionOurClient from '~/modules/Offer/components/EmoutionOurClient.vue';
import {useBaseStore} from '~/modules/BaseModule/base.store';
import {getTranslateBySpanTag} from '~/helpers/baseFunction';

definePageMeta({
  layout: 'offer',
  middleware: 'auth',
});

const {t, locale} = useI18n();
const base = useBaseStore();
const user = useUserStore();
const showVideoModal = ref(false);
const router = useRouter();
const isMount = ref(false);

const homeTitle = t('Home');
const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;

const transformSpaces = computed(() =>
  getTranslateBySpanTag(t('transformSpaces')),
);

// после перевода всех изображений на удалённый сервер, настроить прелоуд главного файла
useHead({
  link: [
    {
      rel: 'preload',
      as: 'image',
      href: `${staticUrl}/images/main-bg-offer.webp`,
    },
  ],
  title: `${t(runtimeConfig.public.vueAppTitle)}${
    homeTitle ? ` - ${homeTitle}` : ''
  }`,
  meta: [
    {
      name: 'description',
      content: `${t('homeMetaDesc')}`,
    },
  ],
  charset: 'utf-8',
});
useSeoMeta({
  ogTitle: `${t(runtimeConfig.public.vueAppTitle)}${
    homeTitle ? ` - ${homeTitle}` : ''
  }`,
  description: `${t('homeMetaDesc')}`,
  ogDescription: `${t('homeMetaDesc')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
  ogUrl: 'https://dreamflat.design/',
  ogImageAlt: 'DreamFlat',
});

const video = ref('promo-yt');

function startVideo(source: string) {
  video.value = source;
  showVideoModal.value = true;
}

import {goTo} from '~/helpers/baseFunction';

const actionHandler = () => {
  goTo('#tariff');
};

watch(user.$state, (_) => {
  if (user.isLoggedIn && user.specialLink) {
    actionAfterLogin(user.specialLink);
  }
});

const actionAfterLogin = (specialLink: string) => {
  router.push(specialLink);
};

const isMobile = computed(() => base.isMobile);

onMounted(() => {
  isMount.value = true;
  gaUserVisitedOfferPage();
});
</script>

<style lang="scss" scoped>
.main-wrapper {
  width: 100%;
  min-height: calc(100vh);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  .container {
    max-width: 1128px;
    display: flex;
    flex-direction: column;
    @media (max-width: 1128px) {
      padding: 0 16px;
    }
    @media (max-width: $lg) {
      gap: $g-4;
    }

    .landing {
      width: 100%;
      height: 100%;
      min-height: calc(100vh);
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .info-box {
        width: 1080px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        gap: $g-1;

        &__before {
          color: var(--var-white-000);
          font-size: $fs-18;
          margin-bottom: $mb-2;
        }

        &__title {
          color: #fff;
          font-family: Segoe UI;
          font-size: 48px;
          font-style: normal;
          font-weight: 600;
          line-height: 110%; /* 79.2px */
          max-width: 45vw;
          display: flex;
          flex-direction: column;

          span {
            width: fit-content;
          }

          @media (max-width: 1550px) {
            max-width: 70vw;
          }
          @media (max-width: $lg) {
            font-size: 28px;
            max-width: 100vw;
            display: inline-block;
          }
        }

        &__subtitle {
          margin-top: 48px;
          margin-bottom: 9vh;
          color: #fff;
          text-align: center;
          font-family: Segoe UI;
          font-size: 24px;
          font-style: normal;
          max-width: 40vw;
          font-weight: 400;
          line-height: 140%; /* 33.6px */
          letter-spacing: 0.72px;
          text-align: left;
          @media (max-width: $lg) {
            font-size: 20px;
            letter-spacing: 0.6px;
            letter-spacing: 0.6px;
            margin-bottom: 40px;
            max-width: 70vw;
          }
          @media (max-width: $md) {
            margin-top: 12px;
            margin-bottom: 12px;
            max-width: 90vw;
          }
        }

        &__btn-wrapper {
          display: flex;
          gap: $g-4;
          width: 100%;

          @media (max-width: $md) {
            flex-direction: column;
            width: 100%;
          }
        }

        .btn {
          max-width: 340px;
          width: 100%;
          margin-top: 16px;
          font-size: 18px;
          font-weight: 600;
          line-height: 24px; /* 133.333% */
          letter-spacing: 0.36px;

          @media (max-width: $md) {
            max-width: 100%;
          }
        }

        .dwnload-btn {
          padding: 16px 64px;
          height: 64px;
          max-width: 355px;

          @media (max-width: $md) {
            max-width: unset;
          }
        }

        .btn_lg {
          padding: 16px 60px !important;

          svg {
            min-width: 20px;
          }
        }

        .mobile-btn {
          display: none;
        }
      }

      @media (min-width: 2000px) {
        min-height: 1000px;
      }
    }
  }

  .bg {
    position: absolute;
    left: 0;
    top: 36px;
    width: 100%;
    height: calc(100vh - 36px);
    z-index: -1;

    @media (min-width: 2000px) {
      height: 1000px;
    }
    @media (max-width: $md) {
      background-position: left;
    }
  }
}
</style>
